<template>
    <div class="tree-select">
      <div class="tree-select-input" @click="toggleDropdown">
        <span v-if="selectedLabels.length">{{ selectedLabels.join(', ') }}</span>
        <span v-else class="placeholder">בחר ערך מהרשימה</span>
        <span class="arrow">{{ isOpen ? '▲' : '▼' }}</span>
      </div>
      
      <div v-show="isOpen" class="tree-dropdown">
        <input 
          v-model="searchText" 
          type="text" 
          placeholder="חיפוש..."
          class="tree-search"
          @click.stop
        />
        <div class="tree-items">
          <tree-item
            v-for="item in filteredItems"
            :key="item.id"
            :item="item"
            :selected="value"
            @toggle="handleToggle"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import TreeItem from './TreeItem.vue';
  export default {
    name: 'TreeSelect',
    components: {
      TreeItem,
    },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      options: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        isOpen: false,
        searchText: ''
      };
    },
    computed: {
      selectedLabels() {
        const labels = [];
        const findLabels = (items) => {
          items.forEach(item => {
            if (this.value.includes(item.id)) {
              labels.push(item.name);
            }
            if (item.children) {
              findLabels(item.children);
            }
          });
        };
        findLabels(this.options);
        return labels;
      },
      filteredItems() {
        console.log("options", this.options)
        if (!this.searchText) return this.options;
        
        const search = this.searchText.toLowerCase();
        const filterTree = (items) => {
          return items.filter(item => {
            const matchesSearch = (item.name || '').toLowerCase().includes(search);
            const hasMatchingChildren = item.children ? filterTree(item.children).length > 0 : false;
            
            if (matchesSearch || hasMatchingChildren) {
              if (item.children) {
                item.children = filterTree(item.children);
              }
              return true;
            }
            return false;
          });
        };
        
        return filterTree(JSON.parse(JSON.stringify(this.options)));
      }
    },
    methods: {
      toggleDropdown() {
        this.isOpen = !this.isOpen;
      },
      handleToggle(id) {
        // Emit only the id the user clicked. The server expands the
        // hierarchy on its side, so we don't send descendants.
        const selected = [...(this.value || [])];
        const index = selected.indexOf(id);
        if (index > -1) {
          selected.splice(index, 1);
        } else {
          selected.push(id);
        }
        this.$emit('input', selected);
      }
    },
    mounted() {
      document.addEventListener('click', (e) => {
        if (!this.$el.contains(e.target)) {
          this.isOpen = false;
        }
      });
      console.log("mounted", this.options)
      console.log("value", this.value)
    },
    created() {
      console.log("created", this.options)
      console.log("value", this.value)
    }
  };
  </script>
  
  <style scoped>
  .tree-select {
    position: relative;
    width: 100%;
  }
  
  .tree-select-input {
    border: 1px solid #ccc;
    padding: 10px;
    cursor: pointer;
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 40px;
  }
  
  .placeholder {
    color: #999;
  }
  
  .tree-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ccc;
    border-top: none;
    max-height: 300px;
    overflow-y: auto;
    z-index: 1000;
  }
  
  .tree-search {
    width: 100%;
    padding: 8px;
    border: none;
    border-bottom: 1px solid #eee;
    outline: none;
  }
  
  .tree-items {
    padding: 5px;
  }
  </style>